module.exports = __webpack_public_path__ + "static/media/MHRP51N0002.898e7283.svg";